module.exports = __webpack_public_path__ + "img/18_45.88822ba4.png";